var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.data.title)?_c('h1',{staticClass:"title is-size-3"},[_vm._v(" "+_vm._s(_vm.$t(_vm.data.title))+" ")]):(_vm.data.subtitle)?_c('h2',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.$t(_vm.data.subtitle))+" ")]):(_vm.hasButton)?_c('Button',{attrs:{"data":_vm.data.button}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }